// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const userTechnicalQuery = gql`
  query (
    $dateRange: String = ""
    $userId: ID = ""
    $email: String = ""
    $organizationId: ID = ""
    $isAllOrgs: Boolean
  ) {
    getUserTechnical(
      dateRange: $dateRange
      userId: $userId
      email: $email
      organizationId: $organizationId
      isAllOrgs: $isAllOrgs
    ) {
      chart {
        queryname
        userid
        ym
        value
        propened
        prmerged
        issuesopen
        issuesclosed
        added
        deleted
        coauthored
        commits
      }
      stats {
        prMergedCount
        prOpenedCount
        issueOpenedCount
        issueClosedCount
        commitCount
      }
    }
  }
`;

export interface userTechnicalGraphQueryVariables {
  userId?: string;
  organizationId?: string;
  email?: string;
  dateRange?: string;
  isAllOrgs?: boolean;
}

export interface userTechnicalGraphQueryResponse {
  getUserTechnical: userTechnicalRow[];
}

export interface userTechnicalRow {
  queryname: string;
  userid: string;
  ym: string;
  quarter: number;
  value: number;
  propened: number;
  prmerged: number;
  issuesopen: number;
  issuesclosed: number;
  added: number;
  deleted: number;
  coauthored: number;
  commits: number;
}

export interface userTechnicalStats {
  prMergedCount: number;
  prOpenedCount: number;
  issueOpenedCount: number;
  issueClosedCount: number;
  commitCount: number;
}

export interface UserTechnicalResponse {
  chart: userTechnicalRow[];
  stats: userTechnicalStats;
}
